import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_v_radio = _resolveComponent("v-radio");
    const _component_v_radio_group = _resolveComponent("v-radio-group");
    const _component_InputRow = _resolveComponent("InputRow");
    const _component_v_autocomplete = _resolveComponent("v-autocomplete");
    const _component_v_select = _resolveComponent("v-select");
    return (_openBlock(), _createElementBlock("div", null, [
        _createVNode(_component_InputRow, {
            label: _ctx.$t(`${_ctx.lc}later_use_yn`),
            "is-required": ""
        }, {
            default: _withCtx(() => [
                _createVNode(_component_v_radio_group, {
                    modelValue: _ctx.laterUseYnComputed,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.laterUseYnComputed) = $event)),
                    name: "laterUseYnComputed",
                    inline: "",
                    density: "compact",
                    "hide-details": "auto"
                }, {
                    default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.useOptionList, (option, key) => {
                            return (_openBlock(), _createBlock(_component_v_radio, {
                                key: key,
                                label: option.label,
                                value: option.value
                            }, null, 8 /* PROPS */, ["label", "value"]));
                        }), 128 /* KEYED_FRAGMENT */))
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["modelValue"])
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label"]),
        _createVNode(_component_InputRow, {
            label: _ctx.$t(`${_ctx.lc}distance_product`),
            "is-required": ""
        }, {
            default: _withCtx(() => [
                _createVNode(_component_v_autocomplete, {
                    "item-title": "text",
                    "item-value": "value",
                    modelValue: _ctx.distanceProductComputed,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.distanceProductComputed) = $event)),
                    items: _ctx.distanceProductOptionList,
                    variant: "outlined",
                    density: "compact",
                    "hide-details": "auto",
                    onKeyup: _cache[2] || (_cache[2] = ($event) => ($event.stopPropagation())),
                    onBlur: _cache[3] || (_cache[3] = ($event) => (_ctx.handleBlurDistanceProductTypeField(_ctx.formData.distanceProduct)))
                }, null, 8 /* PROPS */, ["modelValue", "items"])
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label"]),
        _createVNode(_component_InputRow, {
            label: _ctx.$t(`${_ctx.lc}hub_configuration.options.is_worker_support_amount`),
            "is-required": ""
        }, {
            default: _withCtx(() => [
                _createVNode(_component_v_radio_group, {
                    modelValue: _ctx.isWorkerSupportAmountComputed,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_ctx.isWorkerSupportAmountComputed) = $event)),
                    name: "isWorkerSupportAmountComputed",
                    inline: "",
                    density: "compact",
                    "hide-details": "auto"
                }, {
                    default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableOptionList, (option, key) => {
                            return (_openBlock(), _createBlock(_component_v_radio, {
                                key: key,
                                label: option.label,
                                value: option.value
                            }, null, 8 /* PROPS */, ["label", "value"]));
                        }), 128 /* KEYED_FRAGMENT */))
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["modelValue"])
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label"]),
        _createVNode(_component_InputRow, {
            label: _ctx.$t(`${_ctx.lc}hub_configuration.options.is_customer_message_service`),
            "is-required": ""
        }, {
            default: _withCtx(() => [
                _createVNode(_component_v_select, {
                    "item-title": "text",
                    "item-value": "value",
                    modelValue: _ctx.isCustomerMessageServiceComputed,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_ctx.isCustomerMessageServiceComputed) = $event)),
                    items: _ctx.isCustomerMessageServiceOptionList,
                    variant: "outlined",
                    density: "compact",
                    "hide-details": "auto"
                }, null, 8 /* PROPS */, ["modelValue", "items"])
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label"]),
        _createVNode(_component_InputRow, {
            label: _ctx.$t(`${_ctx.lc}hub_configuration.options.is_delivery_status`),
            "is-required": ""
        }, {
            default: _withCtx(() => [
                _createVNode(_component_v_radio_group, {
                    modelValue: _ctx.isDeliveryStatusComputed,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_ctx.isDeliveryStatusComputed) = $event)),
                    name: "isDeliveryStatusComputed",
                    inline: "",
                    density: "compact",
                    "hide-details": "auto"
                }, {
                    default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.useOptionList, (option, key) => {
                            return (_openBlock(), _createBlock(_component_v_radio, {
                                key: key,
                                label: option.label,
                                value: option.value
                            }, null, 8 /* PROPS */, ["label", "value"]));
                        }), 128 /* KEYED_FRAGMENT */))
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["modelValue"])
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label"])
    ]));
}
